import { createAsyncThunk } from "@reduxjs/toolkit";
import { MainProgramService } from "Services/axios/MainProgram.service";
import { toast } from "react-toastify";
import { handleApiError } from 'Features/Common/ErrorHandler';

export const fetchMainProgram = createAsyncThunk(
	"MainPrograms/fetchMainPrograms",
	async (filters) => {
		try {
			const response = await MainProgramService.getAll(filters);
			return response.data;
		} catch (error) {
			handleApiError(error);
			throw error;
		}
	}
);

export const submitMainProgram = createAsyncThunk(
	"addMainProgram/submitMainProgram",
	async (data) => {
		try {
			const formData = new FormData();
			formData.append("title", data.title);
			formData.append("batch", data.batch);
			formData.append("header_desc", data.header_desc);
			formData.append("content_desc", data.content_desc);
			formData.append("video_promo", data.video_promo);
			if (data.point.length > 0) {
				formData.append("point", JSON.stringify(data.point));
			} else {
				formData.append("point", JSON.stringify([]));
			}
			formData.append("is_tryout_only", data.is_tryout_only);
			formData.append("is_private", data.is_private);
			formData.append("is_recommended", data.is_recommended);
			if (data.is_recommended == 1) {
				formData.append("title_recommended", data.title_recommended);
				formData.append("description_recommended", data.description_recommended);
			} else {
				formData.append("title_recommended", "");
				formData.append("description_recommended", "");
			}
			if (data.slug !== data.old_slug && data.is_campus_event == 1) {
				formData.append("slug", data.slug || "delete");
			} else if (data.is_campus_event == 0) {
				formData.append("slug", "delete");
			}
			data.image && formData.append("image", data.image);
			data.attachment && formData.append("attachment", data.attachment);
			if (data.category_id.id) {
				formData.append('category_id', data.category_id.id);
			} else {
				formData.append('category_id', data.category_id);
			}
			formData.append("order", data.order);
			let response;
			if (data.isUpdate) {
				response = await MainProgramService.update(data.id, formData);
			} else {
				response = await MainProgramService.create(formData);
			}

			// pastikan response valid sebelum menampilkan success toast
			if (!response || !response.status || response.status < 200 || !response.data || !response.data.data) {
				// anggap ini error agar masuk ke catch untuk handling yang konsisten
				throw new Error('Invalid response from server');
			}
			const returnedData = response.data.data;
			toast.success(data.isUpdate ? 'Program berhasil diubah.' : 'Program berhasil ditambahkan.', {
				position: toast.POSITION.TOP_RIGHT
			});
			data.successCallback && data.successCallback();
			return returnedData;
		} catch (error) {
			handleApiError(error);
			throw error;
		}
	}
);

export const deleteMainProgram = createAsyncThunk(
	"MainPrograms/deleteMainProgram",
	async (id) => {
		try {
			const response = await MainProgramService.delete(id);
			return response.data.data;
		} catch (error) {
			handleApiError(error);
			throw error;
		}
	}
);

export const attachDetachMainProgram = createAsyncThunk(
	"MainPrograms/attachDetachMainProgram",
	async (data) => {
		try {
			const formData = new FormData();
			formData.append("type", data.type);
			// jika type attach jalankan dibawah, jika detach kirim id saja tanpa looping
			data.membership_id.forEach((item, index) => {
				formData.append(`membership_id[${index}]`, item.value);
			});
			await MainProgramService.attachDetach(data.id, formData);
			return true;
		} catch (error) {
			handleApiError(error);
			throw error;
		}
	}
);

export const replicateMainProgram = createAsyncThunk(
	"MainPrograms/replicateMainProgram",
	async (id) => {
		try {
			const response = await MainProgramService.replicate(id);
			return response;
		} catch (error) {
			handleApiError(error);
			throw error;
		}
	}
);